var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 9,
    viewBox: "0 0 26 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0189 3.5H5.88679V0.5C5.88679 0.3 5.78868 0.1 5.59245 0C5.39623 0 5.2 0 5.00377 0.1L0.196226 4.1C0.0981132 4.2 0 4.3 0 4.5C0 4.7 0.0981132 4.8 0.196226 4.9L5.10189 8.9C5.2 8.9 5.29811 9 5.39623 9C5.49434 9 5.49434 9 5.59245 9C5.78868 8.8 5.88679 8.7 5.88679 8.5V5.5H25.0189C25.6075 5.5 26 5.1 26 4.5C26 3.9 25.6075 3.5 25.0189 3.5Z",
    fill: "#E2DFFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.51dc69663d320ab73f076c55bc958932.svg";
export { ForwardRef as ReactComponent };